<main *ngIf = "pageContent">
	<div class="review-wrapper" *ngIf="!ibmflag">
		<!-- <h1 *ngIf = "!unclaim"> {{pageContent.heading}} </h1> -->
		<h1><strong>{{pageContent.heading1}} </strong></h1>
		<div class="alert valign-children-middle" *ngIf="error">
			<div class="alert-error" role="img" aria-label="Alert.">
				<i class="icon-badgealert"></i>
			</div>
			<div>
				<span [innerHTML] = "pageContent.messages.failure"> </span>
			</div>
		</div>
		<!-- <h2>{{prodcode}}</h2> -->
		<!-- <h2>{{ prodcode === 'Apple Business Manager' ? 'Apple Business' : prodcode }}</h2> -->
		<h2>
		{{
			prodcode === 'Apple Business Manager'
			? 'Apple Business'
			: (prodcode === 'Samsung Knox Mobile'
				? 'Samsung Knox Mobile Enrollment'
				: prodcode)
		}}
		</h2>
		<!-- <h2 *ngIf = "!unclaim"> {{pageContent.subhead}}</h2> -->
		<!-- FAN equals 1 -->
		<div *ngIf="FANList.length == 1">
			<!-- <p *ngIf="!unclaim"> The following account will be removed. </p> -->
			<p class="banner"> 
				<i class="icon-alert" role="img" aria-label="Alert"></i><strong>The following account will be removed.</strong> 
			</p>
			<app-customgrid [gridOptions]="gridOptions"></app-customgrid>
		</div>
		<!-- FAn Less than 5 -->
		<div *ngIf="FANList.length >= 2 && FANList.length <= 5">
			<!-- <p *ngIf="!unclaim"> The following {{FANList.length}} accounts will be removed. </p> -->
			<p class="banner"> 
				<i class="icon-alert" role="img" aria-label="Alert"></i><strong> The following {{FANList.length}} accounts will be removed.</strong> 
			</p>
			<app-customgrid [gridOptions]="gridOptions"></app-customgrid>
		</div>
		<!-- FAN Greater than 5 -->
		<div *ngIf="FANList.length > 5">
		<!-- <p *ngIf="!unclaim"> You are removing {{FANList.length}} accounts.  {{text}} </p> -->
		<p class="banner"> 
			<i class="icon-alert" role="img" aria-label="Alert"></i><strong>You are removing {{FANList.length}} accounts.  {{text}}</strong> 
		</p>
			<app-accordion [accordion]="accordionList" [accordionController]=false>
				<app-accordion-list *ngFor="let acc of accordionList; let i = index" [option]='acc' (click)="onClick()" [isSubAccordion]=true>
					<app-customgrid [gridOptions]="gridOptions"></app-customgrid>
				</app-accordion-list>
			</app-accordion>
		</div>
		<div class="panel panel-header">
			<div *ngIf="FANList.length == 1" class="panel-message">
				<!-- <h4 *ngIf = "!unclaim"> Review foundation account for cancellation</h4> -->
				<h4> {{pageContent.content_head1}}</h4>
				<!-- <p> {{pageContent.content_subhead1}}</p> -->
				<p> {{pageContent.content_subhead}}</p>
				<!-- <p *ngIf = "!unclaim"> {{pageContent.content_subhead}}</p>
				<p *ngIf = "!unclaim" [innerHTML] = "pageContent.content_link"></p> -->
				<p [innerHTML] = "pageContent.content_link1"></p>
				<p>
					<label class="checkbox">
						<input type="checkbox" (change)="changeEvent($event)">
						<i class="skin"></i>
						<span>{{pageContent.confirm}}</span>
					</label>
				</p>
			</div>
			<div *ngIf="FANList.length > 1" class="panel-message">
				<h4> {{pageContent.content_head}}</h4>
				<!-- <p>{{pageContent.content_subhead1}}</p> -->
				<p>  {{pageContent.content_subhead}}</p>
				<!-- <p *ngIf = "!unclaim"> {{pageContent.content_subhead}}</p>
				<p *ngIf = "!unclaim" [innerHTML] = "pageContent.content_link"></p> -->
				<p [innerHTML] = "pageContent.content_link1"></p>
				<p>
					<label class="checkbox">
						<input type="checkbox" (change)="changeEvent($event)">
						<i class="skin"></i>
						<span>{{pageContent.confirm}}</span>
					</label>
				</p>
			</div>
		</div>
		<div class="text-right buttons-section">
			<!-- <button [checkImpersonator]="FANList.length == 0" *ngIf="!unclaim" (click)="continueToNext()" aria-label="Remove accounts."  class="btn btn-secondary pull-right"> {{pageContent.buttons.submit}} </button> -->
			<button [disabled]="!this.selectedbox" (click)="continueToNext()" aria-label="Remove accounts."  class="btn btn-secondary pull-right"> {{pageContent.buttons.submit}} </button>
			<a href="javascript:void(0)" (click)="backToPreviousPage($event)"  
			class="btn btn-link btn-block btn-cancel btnCancel"> {{pageContent.buttons.cancel}} </a>
		</div>
	</div>
	<div class="review-wrappermdm" *ngIf="ibmflag">
		<h1> {{pageContent.heading}} </h1>
		<div class="alert valign-children-middle" *ngIf="error">
			<div class="alert-error" role="img" aria-label="Alert.">
				<i class="icon-badgealert"></i>
			</div>
			<div>
				<span [innerHTML] = "pageContent.messages.failure"> </span>
			</div>
		</div>
		<h2> {{pageContent.subhead}}</h2>
		<!-- FAN equals 1 -->
		<div *ngIf="FANList.length == 1">
			<p> The following account will be removed. </p>
			<app-customgrid [gridOptions]="gridOptions" (onDataChange)="onRowClick($event)"></app-customgrid>
		</div>
		<!-- FAn Less than 5 -->
		<div *ngIf="FANList.length >= 2 && FANList.length <= 5">
			<p> The following {{FANList.length}} accounts will be removed. </p>
			<app-customgrid [gridOptions]="gridOptions" (onDataChange)="onRowClick($event)"></app-customgrid>
		</div>
		<!-- FAN Greater than 5 -->
		<div *ngIf="FANList.length > 5">
		<p> You are removing {{FANList.length}} accounts.  {{text}} </p>
			<app-accordion [accordion]="accordionList" [accordionController]=false>
				<app-accordion-list *ngFor="let acc of accordionList; let i = index" [option]='acc' (click)="onClick()" [isSubAccordion]=true>
					<app-customgrid [gridOptions]="gridOptions" (onDataChange)="onRowClick($event)"></app-customgrid>
				</app-accordion-list>
			</app-accordion>
		</div>
		<div class="panel panel-header">
			<div *ngIf="FANList.length == 1" class="panel-message">
				<h4> Review foundation account for cancellation</h4>
				<p [innerHTML] = "pageContent.content_link"></p>
			</div>
			<div *ngIf="FANList.length > 1" class="panel-message">
				<h4> {{pageContent.content_head}}</h4>
				<p> {{pageContent.content_subhead}}</p>
				<p [innerHTML] = "pageContent.content_link"></p>
			</div>
		</div>
		<div class="text-right buttons-section">
			<button [checkImpersonator]="FANList.length == 0" (click)="continueToNextmdm()" aria-label="Remove accounts."  class="btn btn-secondary pull-right"> {{pageContent.buttons.submit}} </button>
			<a href="javascript:void(0)" (click)="backToPreviousPagemdm($event)"  
			class="btn btn-link btn-block btn-cancel btnCancel"> {{pageContent.buttons.cancel}} </a>
		</div>
	</div>
</main>